export default "__VITE_ASSET__e72105dd__"